import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import WeeklyWorkoutPlanView from "@/components/workouts/WeeklyWorkoutPlanView";

export default function ClientWeeklyWorkoutModal({ client, open, onOpenChange }) {
  if (!client) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto w-[calc(100%-2rem)] rounded-xl">
        <DialogHeader>
          <DialogTitle className="font-display">Weekly Workout Plan — {client.full_name}</DialogTitle>
        </DialogHeader>
        <WeeklyWorkoutPlanView userId={client.id} />
      </DialogContent>
    </Dialog>
  );
}